import { TBroadcastTypePickerOptions } from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/broadcast-type-picker/broadcast-type-picker.types';
import { EBroadcastTypes, SessionLayout } from '@/types/session.types';

const getSessionLayoutFromSelectedBroadcastType = (type: TBroadcastTypePickerOptions): Partial<SessionLayout> => {
  // embeded video cannot have overlay chat
  if (type === EBroadcastTypes.embed) {
    return {
      overlayChat: false,
    };
  }

  return {};
};

export default getSessionLayoutFromSelectedBroadcastType;
